import moment from 'moment'

export class Helpers {
  static dateFormat (date) {
    return moment(date).format('MMM Do YY')
  }

  static dateTimeFormat (date) {
    return moment(date).format('MMM Do YY HH:mm:ss')
  }
}



// WEBPACK FOOTER //
// ./src/services/helpers.service.js